export function setNotas(state, notas) {
  state.notas = notas;
}
